<template>
  <div>
    <v-dialog v-model="showWindow" scrollable max-width="450px" persistent>
      <v-card>
        <v-card-actions>
          <h3 class="pl-2">
            {{ $t('viewSettings.goods_export.ozon_seller_api_parameters') }}
          </h3>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="close"
            :disabled="isDisabledForm"
            :loading="isDisabledForm"
          >
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <v-form ref="form">
            <v-text-field
              outlined
              :disabled="isDisabledForm"
              hide-details
              class="mt-2"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
              v-model="emptyParameters.client_id"
              label="Client Id"
            ></v-text-field>

            <v-text-field
              outlined
              :disabled="isDisabledForm"
              hide-details
              class="mt-2"
              v-model="emptyParameters.api_key"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
              label="API key"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider class=""></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            color="red"
            :disabled="isDisabledForm"
            :loading="isDisabledForm"
            class="white--text"
            @click="close"
          >
            {{ $t("common.close") }}
          </v-btn>
          <v-btn
            elevation="0"
            color="primary"
            :disabled="isDisabledForm"
            :loading="isDisabledForm"
            @click="submit"
          >
            <span>{{ $t("common.save") }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  name: "OzonSellerApiParametersForm",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    emptyParameters: {
      client_id: null,
      api_key: null,
    },
  }),
  methods: {
    close() {
      this.showWindow = false;
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      this.$store
        .dispatch("ozon_seller_api/updateParameters", this.emptyParameters)
        .then((updated) => {
          if (updated.id > 0) {
            this.$emit("hide");
          }
        });
    },
  },
  computed: {
    isDisabledForm() {
      return (
        this.savingInProgress || !this.isFetched
      );
    },
    ...mapFields("ozon_seller_api", ["parameters", "isFetched"]),
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("hide");
        this.$refs.form.resetValidation();
      },
    },
  },
  watch: {
    show(to) {
      if(to) {
        this.$store.dispatch("ozon_seller_api/getParameters").then((one) => {
          if (one && one.id) {
            this.emptyParameters = this.parameters;
          }
        });
      }
    },
  },
};
</script>

<style scoped></style>
